import { FunctionComponent, useCallback } from "react";
import "./Header.scss";
import { useNavigate, useLocation } from "react-router-dom";
import images from "../../assets/images";
import { useAppDispatch, useAppSelector } from "../../redux/app/hooks";
import { logout } from "../../redux/slices/authSlice";
import { trackButtonClick } from "../../firebase/analyticsHelper";
import { ButtonClickEvents } from "../../firebase/constants/events";


const Header: FunctionComponent = () => {
  const navigate = useNavigate();
  const {katonHeaderLogo} = images;
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { isKaton, participantCode, schoolType } = useAppSelector((state) => state.auth);
    
  // navigate to landing page while click header logo
  const onHeaderLogoImageClick = useCallback(() => {
    trackButtonClick(ButtonClickEvents?.LOGO_CLICK, {
        description : "User clicked the header logo",
        page: 'Header'
    });

    const component = isKaton === "facilitator" ? "/facilitator-login?isKaton=facilitator" : isKaton === "participant" ? `/participant-login${location?.search ? location?.search : `?isKaton=participant&code=${participantCode}`}` : (isKaton === "virtualSchool" ? "/?isKaton=virtualSchool" : "/");
    navigate(component);
    dispatch(logout());
  }, [isKaton]);


  //navigate to school admin login page while click school admin label in header
  const onSchoolAdminClick = useCallback(() => {
    trackButtonClick(ButtonClickEvents?.SCHOOL_ADMIN_TEXT_CLICK, {
        description : "User clicked the school admin label",
        page: 'Header'
    });
    navigate('/admin-login');
    dispatch(logout());
  }, []);

  //navigate to teacher login page while click teacher label in header
  const onTeacherClick = useCallback(() => {
    trackButtonClick(ButtonClickEvents?.TEACHER_TEXT_CLICK, {
        description : "User clicked the teacher label",
        page: 'Header'
    });
    // Add your navigation logic here
    navigate('/teacher-login');
    dispatch(logout());
  }, []);

  //navigate to pta page while click pta label in header
  const onPtaClick = useCallback(() => {
    trackButtonClick(ButtonClickEvents?.PTA_TEXT_CLICK, {
        description : "User clicked the PTA label",
        page: 'Header'
    });
    navigate('/pta-verifyCode');
    dispatch(logout());
  }, []);

  return (
    <section className="sectionHeader">
      <div className="headercontainer">
        <img
          className={`hdrLogoIcon ${(location.pathname?.includes("/facilitator-login") || location.pathname?.includes("/participant-login"))? "disabled" : ""}`}
          alt="logoImage"
          src={katonHeaderLogo}
          onClick={onHeaderLogoImageClick}
          
        />
          <div className="menuParent">
            <div className="menu">
              <div className={`schoolAdmin ${location.pathname === "/admin-login" ? "active" : ""}`} onClick={onSchoolAdminClick}>
                School Admin
              </div>
              <div className={`teacher ${((location.pathname === "/teacher-login") || (location.pathname === '/teacher-select-class') )? "active" : ""}`} onClick={onTeacherClick}>
                Teacher
              </div>
              <div className={`pta ${location.pathname === "/pta-verifyCode" || location.pathname === "/pta-signup" || location.pathname === "/pta-login" ? "active" : ""}`}  onClick={onPtaClick}>PTA</div>
            </div>
            <button title="hamBurgerMenu" className="icMobileMenu">
              <img className="icMenu2" alt="hamburgerMenu" src="/ic--menu-2.svg" />
            </button>
          </div>
      </div>
    </section>
  );
};

export default Header;
